<template>
  <transition name="fade">
    <v-expansion-panels v-if="modoEdicion" v-model="panelAbierto">
      <v-expansion-panel>
        <v-expansion-panel-header disable-icon-rotate>
          {{ panelConfig.titulo }}
          <template v-slot:actions>
            <v-btn icon v-if="panelAbierto === 0" @click="handleDeleteClick">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <component :is="panelConfig.componente" v-bind="panelConfig.props" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </transition>
</template>
  
  <script>
import ProductoDescripcionForm from "@/components/producto/form/form.producto.descripcion.vue";
import ProductoMarcaForm from "@/components/producto/form/form.producto.marca.vue";
import ProductoCategoriaForm from "@/components/producto/form/form.producto.categoria.vue";

export default {
  name: "ProductoModoEdicionPanels",
  components: {
    ProductoDescripcionForm,
    ProductoMarcaForm,
    ProductoCategoriaForm,
  },
  props: {
    productoSelectedEdit: {
      type: Object,
      required: true,
    },
    modoEdicion: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      panelAbierto: 0,
    };
  },
  computed: {
    panelConfig() {
      const configs = {
        descripcion: {
          titulo: "Descripción",
          componente: "ProductoDescripcionForm",
          props: {
            descripcion: this.productoSelectedEdit?.descripcion_comercial,
          },
        },
        marca: {
          titulo: "Marca",
          componente: "ProductoMarcaForm",
          props: {
            producto: this.productoSelectedEdit,
          },
        },
        categoria: {
          titulo: "Categoría",
          componente: "ProductoCategoriaForm",
          props: {
            producto: this.productoSelectedEdit,
          },
        },
      };
      return configs[this.modoEdicion] || {};
    },
  },
  methods: {
    handleDeleteClick() {
      // Emitimos el evento para quitar el modo edición y el producto seleccionado
      this.$emit("clear-mode-edition");
      this.$emit("clear-product-selected");
    },
  },
  watch: {
    modoEdicion(newVal) {
      if (newVal) {
        this.panelAbierto = 0; // Siempre abre el panel cuando cambia
      }
    },
  },
};
</script>
  
  <style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
  